(function($, window) {

    var stickyPanelSelector = ".js-enquiry-docking-bar";
    var reserveButtonSelector = ".select-cta-new .btn-select-badge";
    var verticalEnquiryFormSelector = ".enquiry-form.vertical";
    var horizontalEnquiryFormSelector = ".enquiry-form.horizontal";
    var isSelectCar = false;
    var $stickyPanel;
    var $verticalEnquiryForm;
    var $horizontalEnquiryForm;
    var $reserveButton;

    var siteNavBottom = 0;
    var elementTop = 0;
    var elementBottom = 0;
    var isloaded = false;

    function isShowPanel() {

        if (!this.length) return true;

        var viewportTop = $(window).scrollTop();

        var viewportBottom = viewportTop + $(window).height();

        return !(elementBottom > viewportTop && elementTop < viewportBottom);
    }

    function isShowPanelForSelect() {

        var viewportTop = $(window).scrollTop() + siteNavBottom;

        return viewportTop > elementBottom;
    }

    function handleStickyPanelVisibility() {

        if (isloaded && $stickyPanel != undefined) {

            var isHidden = $stickyPanel.hasClass("hidden");
            var isShowSticky = isSelectCar ? isShowPanelForSelect() : isShowPanel();

            if (isShowSticky && isHidden) {
                $stickyPanel.removeClass("hidden");
            }

            if (!isShowSticky && !isHidden) {
                $stickyPanel.addClass("hidden");
            }
        }
    }

    $(document).ready(function () {

        $stickyPanel = $(stickyPanelSelector);
        isSelectCar = $stickyPanel.hasClass("select");
        $verticalEnquiryForm = $(verticalEnquiryFormSelector);
        $horizontalEnquiryForm = $(horizontalEnquiryFormSelector);
        $reserveButton = $(reserveButtonSelector);

        var $siteNav = $('.site-nav');
        siteNavBottom = $siteNav.outerHeight();


        if (isSelectCar) {

            if ($reserveButton != undefined && $reserveButton.offset() != undefined) {
                elementTop = $reserveButton.offset().top;
                elementBottom = elementTop + $reserveButton.outerHeight();
            }

        } else {

            if ($verticalEnquiryForm != undefined && $verticalEnquiryForm.offset() != undefined) {
                elementTop = $verticalEnquiryForm.offset().top;
                elementBottom = elementTop + $verticalEnquiryForm.outerHeight();
            }
        }

        isloaded = true;

        handleStickyPanelVisibility();

    });

    let throttleTimer;
    const throttle = (callback, time) => {
        if (throttleTimer) return;
        throttleTimer = true;
        setTimeout(() => {
            callback();
            throttleTimer = false;
        }, time);
    }

    $(window).on('scroll', function () {
        throttle(handleStickyPanelVisibility, 250);
    });

    $('a.csn-btn', $stickyPanel).click(function () {

        var $trackerOffset = isSelectCar ? $verticalEnquiryForm.offset() : $horizontalEnquiryForm.offset();

        if ($trackerOffset == undefined) return;

        $('html, body').animate({ scrollTop: $trackerOffset.top - 180 }, 750);

    });

})(jQuery, window);

